import React from 'react';
import './ModalNewUser.css'

const ModalOneReg = ({errLogin, setErrLogin}) => {

    return (
        <div className={errLogin ? "modal active" : "modal"} onClick={() => setErrLogin(false)}>
            <div className={errLogin ? "modal__content active" : "modal__content"} onClick={e => e.stopPropagation()}>

                <h2>Пользователь с таким ником уже зарегистрирован</h2>

                <div className="btn__new__user__block__reg">
                    <div className="cl-btn-6" onClick={() => setErrLogin(false)}>
                        <div className="cl-btn-6-in">
                            <div className="cl-btn-6-txt">Закрыть</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ModalOneReg;